export default {"src":"/_next/static/media/ic-instagram.58a927c5.svg","height":32,"width":31};